const components = new Map()
import { path } from 'ramda'

components.set('description', ctx => ({
  key: 'description',
  defaultPlacement: 'presentation',
  component: 'InputComponent',
  props: {
    label: ctx.labels.description,
    required: true,
  },
  slots: {
    default: [{ component: 'RichTextComponent' }],
  },
}))

components.set('media.logo', ctx => ({
  component: 'MediaComponent',
  key: 'media.logo',
  defaultPlacement: 'presentation',
  props: {
    label: ctx.labels['media.logo'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    description: false,
  },
}))

components.set('media.logoInverted', ctx => ({
  key: 'media.logoInverted',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels['media.logoInverted'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    description: false,
  },
}))

components.set('media.favicon', ctx => ({
  key: 'media.favicon',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.favicon,
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: { maxWidth: 200 } },
    description: false,
  },
}))
components.set('media.cover', ctx => ({
  key: 'media.cover',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.cover,
    placement: 'outside',
    size: 'contain',
    multiple: 'multiple',
    uploadOptions: { compression: 'gallery' },
    types: ctx.types,
    required: true,
  },
  slots: {
    ['after-label']: [{ component: 'MediaRecommendation', props: { value: 'cover' } }],
  },
}))

components.set('media.gallery', ctx => ({
  key: 'media.gallery',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.gallery,
    placement: 'outside',
    size: 'contain',
    multiple: 'multiple',
    uploadOptions: { compression: 'gallery' },
    types: ctx.types,
  },
  slots: {
    ['after-label']: [{ component: 'MediaRecommendation', props: { value: 'gallery' } }],
  },
}))

components.set('media.brochure', ctx => ({
  key: 'media.brochure',
  defaultPlacement: 'presentation',
  component: 'FileComponent',
  props: {
    label: ctx.labels.brochure,
    multiple: 'multiple',
    accept: '.pdf',
  },
  slots: {
    ['drop-message']: [{ component: 'FileOnDrop' }],
  },
}))

components.set('media.attachments', ctx => ({
  key: 'media.attachments',
  defaultPlacement: 'presentation',
  component: 'FileComponent',
  props: {
    label: ctx.labels.attachments,
    multiple: 'multiple',
  },
}))

components.set('themeColor', ctx => ({
  key: 'themeColor',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('primaryColor'),
    'data-field': 'themeColor',
  },
}))

components.set('themeColorSecondary', ctx => ({
  key: 'themeColorSecondary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('secondaryColor'),
    'data-field': 'themeColorSecondary',
  },
}))

components.set('settings', ctx => ({
  key: 'metadata.siteSettings',
  defaultPlacement: 'theme',
  component: 'PageSettings',
  props: {
    data: ctx.data,
    label: ctx.$t('settings'),
    'data-field': 'settings',
  },
}))

components.set('flatfinder', ctx => ({
  key: 'flatfinder',
  defaultPlacement: 'flatfinder',
  component: 'Flatfinder',
  props: {
    'data-field': 'flatfinder',
  },
}))

components.set('relation', ctx => ({
  key: 'publishing.relation',
  defaultPlacement: 'publishing',
  component: 'ProjectPublishingRelation',
  props: {
    data: ctx.data,
    'data-field': 'relation',
  },
  condition: path(['metadata', 'publishOnPage'], ctx.item) && !['tase', 'skake', 'kveda', 'fjelge', 'livd', 'tuft', 'stogge'].includes(ctx.item.theme)
}))



export default components
